/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriAxiosPost, getMarkerIcon, copiriPortalRequest } from '../../api/api'; // eslint-disable-next-line
import config from '../../config/config'; // eslint-disable-next-line
import CopiriLoader from '../../common/CopiriLoader'; // eslint-disable-next-line
import { Badge } from 'react-bootstrap';
import LodgeHistoryModal from './LodgeHistoryModal.js'; // eslint-disable-next-line
import LodgeAddressModal from '../LodgeAddressModal'; // eslint-disable-next-line
import LodgeContentModal from './LodgeContentModal'; // eslint-disable-next-line
import 'leaflet/dist/leaflet.css'; // eslint-disable-next-line
import { Map, Marker, Popup, Circle, TileLayer } from 'react-leaflet';
import 'leaflet.tilelayer.colorfilter'; // eslint-disable-next-line
import L from 'leaflet'; // eslint-disable-next-line
import 'react-leaflet-fullscreen/dist/styles.css'; // eslint-disable-next-line
import icon from '../../../assets/img/lodges/masonic_craft.png'; // eslint-disable-next-line
import iconShadow from '../../../assets/img/lodges/masonic_craft.png'; // eslint-disable-next-line
const filter = ['bright:101%', 'contrast:101%', 'hue:23deg', 'saturate:225%'];

let DefaultIcon = L.icon({
	iconUrl: icon,
	iconAnchor: null,
	popupAnchor: [-0, -0],
	shadowAnchor: null,
	iconSize: [45, 65]
});
L.Marker.prototype.options.icon = DefaultIcon;
const LodgeModalContentSection = props => {
	const { lodgeData, pageLanguageContent, updateLodgeModal } = props;
	const [showHideHistoryModal, setShowHideHistoryModal] = useState(false);
	const [showHideAddressModal, setShowHideAddressModal] = useState(false);
	const [showHideContentModal, setShowHideContentModal] = useState(false);
	const [contentType, setContentType] = useState('');
	const [headerLabel, setHeaderLabel] = useState('');
	const [historyText, setHistoryText] = useState('');
	const [id, setId] = useState('');
	const [lat, setLat] = useState('');
	const [long, setLong] = useState('');
	let map = useRef(null); // eslint-disable-next-line
	const egMap = useRef();
	useEffect(() => {
		if (lodgeData['id']) {
			setId(lodgeData['id']);
			getLodgeAddress(lodgeData['id']);
		}
		// eslint-disable-next-line
	}, [lodgeData['id']]);

	/* initial function to get the Address data */
	function getLodgeAddress(id) {
		const formdata = new FormData();
		formdata.append('action', 'load_address');
		formdata.append('id', id);
		copiriAxiosPost(config.portal_url, formdata)
			.then(response => {
				if (response.data.address.latitude && response?.data?.address?.latitude !== '') {
					setLat(response?.data?.address?.latitude);
					setLong(response?.data?.address?.longitude);
				}
				L.tileLayer
					.colorFilter('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
						attribution: null,
						transparent: true,
						url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
						filter: filter
					})
					.addTo(map.current.leafletElement);
				map.invalidateSize();
			})
			.catch(error => {});
	}

	/* function to show history modal */
	// eslint-disable-next-line
	const openLodgeModal = text => {
		setHistoryText(text);
		setShowHideHistoryModal(true);
	};
	/* function to hide history modal */
	const closeHistoryModal = () => {
		setShowHideHistoryModal(false);
	};

	//openLodgeAddressModal
	/* function to show lodge address modal */
	// eslint-disable-next-line
	const openLodgeAddressModal = () => {
		setId(lodgeData['id']);
		setShowHideAddressModal(true);
	};
	/* function to hide lodge address modal */
	const closeLodgeAddressModal = () => {
		setShowHideAddressModal(false);
	};

	/* function to show lodge content modal */

	const openLodgeContentModal = (text, type) => {
		setId(lodgeData['id']);
		setHeaderLabel(text);
		setContentType(type);
		setShowHideContentModal(true);
	};

	/* function to hide lodge content modal */
	const closeLodgeContentModal = () => {
		setShowHideContentModal(false);
	};
	return (
		<>
			<Row className='lodge-middle-content-area'>
				<Col lg={8}>
					{/*<div className='lodge-middle-box'>
						<Row className="align-items-center">
							<Col xs={2}>
								<h6>{pageLanguageContent['CLD028'] ? pageLanguageContent['CLD028'] : ''}:</h6>
							</Col>
							<Col xs={8}>
								<p id="modalAddressField" className="mb-0">
									{lodgeData['address'] &&
										lodgeData['address'].length > 0 &&
										lodgeData['address'].map((item, index) => <span key={index}> {item} </span>)}
								</p>	
							</Col>
							<Col xs={2} className="text-right">
								<div className='ml-auto btns-org'>
										<Badge color={'soft-info'} className='mr-1' onClick={() => openLodgeAddressModal()}>
										<i className='far fa-edit'></i>
									</Badge>
									{lodgeData['address'] && lodgeData['address'].length > 0 ? (
										<Badge color={'soft-info'} className='mr-1' onClick={() => openLodgeModal('address')}>
											<i className='fas fa-eye'></i>
										</Badge>
									) : (
										<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
											<i className='fas fa-eye'></i>
										</Badge>
									)}
								</div>
							</Col>
						</Row>
					</div>*/}
					<div className='lodge-middle-box'>
						<Row className='align-items-center'>
							<Col xs={2}>
								<h6 className='mb-0'>{pageLanguageContent['CLD157'] ? pageLanguageContent['CLD157'] : ''}:</h6>
							</Col>
							<Col xs={8}>
								<p className='mb-0'>{lodgeData['district'] ? lodgeData['district'] : pageLanguageContent['CLD040']}</p>
							</Col>
							<Col xs={2} className='text-right'>
								<div className='ml-auto btns-org'>
									<Badge bg={''} className='mr-1 badge badge-soft-info'>
										<i
											className='far fa-edit'
											onClick={() =>
												openLodgeContentModal(
													pageLanguageContent['CLD157'] ? pageLanguageContent['CLD157'] : '',
													'district'
												)
											}
										></i>
									</Badge>
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								</div>
							</Col>
						</Row>
					</div>
					<div className='lodge-middle-box'>
						<Row className='align-items-center'>
							<Col xs={2}>
								<h6 className='mb-0'>{pageLanguageContent['CLD029'] ? pageLanguageContent['CLD029'] : ''}:</h6>
							</Col>
							<Col xs={8}>
								<p className='mb-0'>{lodgeData['language']}</p>
							</Col>
							<Col xs={2} className='text-right'>
								<div className='ml-auto btns-org'>
									<Badge bg={''} className='mr-1 badge badge-soft-info'>
										<i
											className='far fa-edit'
											onClick={() =>
												openLodgeContentModal(
													pageLanguageContent['CLD134'] ? pageLanguageContent['CLD134'] : '',
													'language'
												)
											}
										></i>
									</Badge>
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								</div>
							</Col>
						</Row>
					</div>
					<div className='lodge-middle-box'>
						<Row className='align-items-center'>
							<Col xs={2}>
								<h6 className='mb-0'>{pageLanguageContent['CLD030'] ? pageLanguageContent['CLD030'] : ''}: </h6>
							</Col>
							<Col xs={8}>
								<p className='mb-0'>{lodgeData['rite']}</p>
							</Col>
							<Col xs={2} className='text-right'>
								<div className='ml-auto btns-org'>
									<Badge bg={''} className='mr-1 badge badge-soft-info'>
										<i
											className='far fa-edit'
											onClick={() =>
												openLodgeContentModal(
													pageLanguageContent['CLD135'] ? pageLanguageContent['CLD135'] : '',
													'rite'
												)
											}
										></i>
									</Badge>
									{/*<Badge color={'soft-info'}  className="mr-1" onClick={() => openLodgeModal('rite')}>
	                                      <i className="fas fa-eye"></i>
	                                    </Badge>*/}
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								</div>
							</Col>
						</Row>
					</div>
					<div className='lodge-middle-box'>
						<Row className='align-items-center'>
							<Col xs={2}>
								<h6 className='mb-0'>{pageLanguageContent['CLD031'] ? pageLanguageContent['CLD031'] : ''}:</h6>
							</Col>
							<Col xs={8}>
								<p className='mb-0'>{lodgeData['ritual']}</p>
							</Col>
							<Col xs={2} className='text-right'>
								<div className='ml-auto btns-org'>
									<Badge bg={''} className='mr-1 badge badge-soft-info'>
										<i
											className='far fa-edit'
											onClick={() =>
												openLodgeContentModal(
													pageLanguageContent['CLD136'] ? pageLanguageContent['CLD136'] : '',
													'ritual'
												)
											}
										></i>
									</Badge>
									{/*<Badge color={'soft-info'}  className="mr-1" onClick={() => openLodgeModal('ritual')}>
                                    <i className="fas fa-eye"></i>
                                  </Badge>*/}
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								</div>
							</Col>
						</Row>
					</div>
					<div className='lodge-middle-box'>
						<Row className='align-middle'>
							<Col xs={2}>
								<h6 className='mb-0 mt-1'>{pageLanguageContent['CLD032'] ? pageLanguageContent['CLD032'] : ''}:</h6>
							</Col>
							<Col xs={8}>
								<p className='mb-0 mt-1' dangerouslySetInnerHTML={{ __html: lodgeData['meetings'] }}></p>
							</Col>
							<Col xs={2} className='text-right'>
								<div className='ml-auto btns-org'>
									<Badge bg={''} className='mr-1 badge badge-soft-info'>
										<i
											className='far fa-edit'
											onClick={() =>
												openLodgeContentModal(
													pageLanguageContent['CLD137'] ? pageLanguageContent['CLD137'] : '',
													'meetings'
												)
											}
										></i>
									</Badge>
									{/*<Badge color={'soft-info'}  className="mr-1" onClick={() => openLodgeModal('meeting')}>
                                    <i className="fas fa-eye"></i>
                                  </Badge>*/}
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								</div>
							</Col>
						</Row>
					</div>
					<div className='lodge-middle-box'>
						<Row className='align-middle'>
							<Col xs={2}>
								<h6 className='mb-0 mt-1'>{pageLanguageContent['CLD033'] ? pageLanguageContent['CLD033'] : ''}:</h6>
							</Col>
							<Col xs={8}>
								<p className='mb-0 mt-1' dangerouslySetInnerHTML={{ __html: lodgeData['notes'] }}></p>
							</Col>
							<Col xs={2} className='text-right'>
								<div className='ml-auto btns-org'>
									<Badge bg={''} className='mr-1 badge badge-soft-info'>
										<i
											className='far fa-edit'
											onClick={() =>
												openLodgeContentModal(
													pageLanguageContent['CLD138'] ? pageLanguageContent['CLD138'] : '',
													'notes'
												)
											}
										></i>
									</Badge>
									{/*<Badge color={'soft-info'}  className="mr-1" onClick={() => openLodgeModal('notes')}>
                                <i className="fas fa-eye"></i>
                              </Badge>*/}
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								</div>
							</Col>
						</Row>
					</div>
				</Col>
				<Col lg={4}>
					<div className='lodge-middle-map'>
						{lat && long ? (
							<Map center={[lat, long]} zoom={17} style={{ minHeight: 250 }} ref={map}>
								<TileLayer
									attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
									url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
								/>
								<Marker position={[lat, long]} draggable={false} icon={DefaultIcon}></Marker>
							</Map>
						) : null}
					</div>
				</Col>
			</Row>
			<LodgeHistoryModal
				lodgeData={lodgeData}
				pageLanguageContent={pageLanguageContent}
				id={id}
				showHideHistoryModal={showHideHistoryModal}
				closeHistoryModal={closeHistoryModal}
				updateLodgeModal={updateLodgeModal}
				historyText={historyText}
			/>

			<LodgeAddressModal
				lodgeData={lodgeData}
				pageLanguageContent={pageLanguageContent}
				id={id}
				showHide={showHideAddressModal}
				closeModal={closeLodgeAddressModal}
				updateLodgeModal={updateLodgeModal}
				closeLodgeAddressModal={closeLodgeAddressModal}
			/>

			<LodgeContentModal
				showHide={showHideContentModal}
				closeModal={closeLodgeContentModal}
				id={id}
				headerLabel={headerLabel}
				contentType={contentType}
				lodgeData={lodgeData}
				updateLodgeModal={updateLodgeModal}
				pageLanguageContent={pageLanguageContent}
			/>
		</>
	);
};
export default LodgeModalContentSection;
